import { CABINET_URL, LANGUAGES } from 'shared/constants'

const declOfNum = (number, titles) => {
  number = Math.abs(number)
  if (Number.isInteger(number)) {
    const cases = [2, 0, 1, 1, 1, 2]

    return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]]
  }
  return titles[1]
}

const getPercentOfNumber = (value = 0, target = 0, isFixed = true) => {
  if (target === 0) {
    return 0
  }

  let percent = (value * 100) / target

  percent = percent > 100 ? 100 : percent

  if (!isFixed) {
    return percent
  }

  return percent > 0 && percent < 1 ? percent.toFixed(1) : percent.toFixed(0)
}

const getClientLanguage = () => {
  const clientLanguage = Object.keys(LANGUAGES).find((lang) => lang.match(navigator.language.slice(0, 2)) !== null)

  if (clientLanguage) {
    return clientLanguage
  }

  return 'en' // default language
}

const getLanguagePrefix = (language) => {
  const prefix = language.split('-')?.[0]

  return prefix ?? language
}

const getLanguageSuffix = (language) => {
  const short = language.slice(0, 2)

  if (short === 'ru') {
    return ''
  }

  return `_${short}`
}

const getLoginUrl = (token) => {
  return `${CABINET_URL}/auth/login/${token}`
}

export { declOfNum, getPercentOfNumber, getClientLanguage, getLanguagePrefix, getLanguageSuffix, getLoginUrl }
